<template>
	<div id="app">
		<HomePage />
	</div>
</template>

<script>
import HomePage from '@/components/HomePage.vue';

export default {
	components: {
		HomePage
	}
};
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';
</style>
